import React from "react";
import { ApiHelper, DateHelper, DeviceInterface, ScreenInterface, UserHelper } from "../../helpers";
import { DisplayBox } from "../../components"
import { Device, ScreenHealth } from ".";


interface Props {
  screen: ScreenInterface
}

export const Devices: React.FC<Props> = props => {

  const [devices, setDevices] = React.useState<DeviceInterface[]>([]);
  const [selectedDevice, setSelectedDevice] = React.useState<DeviceInterface>(null);

  const init = () => {
    setSelectedDevice(null);
    if (props.screen) ApiHelper.get<DeviceInterface[]>("/devices/screen/" + props.screen.id)
      .then(d => setDevices(d || []))
      .catch(err => console.error("Failed to load devices:", err));
  }

  const getDeviceTable = () => {
    const result: React.ReactElement[] = []
    devices?.forEach(d => {
      let name = d.ipAddress;
      if (d.deviceDetails) {
        try {
          const details = JSON.parse(d.deviceDetails);
          if (details.deviceName) name = details.deviceName;
        } catch (error) {
          // If deviceDetails is not valid JSON, treat it as the device name directly
          name = d.deviceDetails;
        }
      }
      const device = d;
      result.push(<tr>
        <td><a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedDevice(device) }} >{name}</a></td>
        <td>{DateHelper.getDisplayDuration(DateHelper.convertToDate(d.lastUpdated))} ago</td>
      </tr>)
    });
    return (<div className="table-responsive">
      <table className="table">
        <tr><th>Name</th><th>Last checkin</th></tr>
        {result}
      </table>
    </div>)
  }


  React.useEffect(init, [props.screen])


  if (selectedDevice) return <Device device={selectedDevice} />
  else {
    if (devices?.length > 0) return (
      <DisplayBox headerIcon="fas fa-tv" headerText="Paired Devices">
        {getDeviceTable()}
      </DisplayBox>
    );
    else if (UserHelper.checkAccess("admin") && props.screen?.id !== 0) return <ScreenHealth screen={props.screen} />
    else return <></>
  }

}